document.addEventListener("DOMContentLoaded", () => {
    const images = document.querySelectorAll('.shop-scene-section__image');
    const divs = document.querySelectorAll('.td-shop-scene-section__products-container');

    function removeClassOnDivs() {
        if (divs && images) {
          divs.forEach(div => {
            div.classList.remove('js-active');
          });
        }
    }

    if (images) {
        images.forEach(image => {
            image.addEventListener('click', removeClassOnDivs);
        });
    }
});